import { OrganizationRequiredDocument } from "./organization-required-document";

export class AccountDocument {
    id: number;
    accountId: number;
    organizationRequiredDocument?: OrganizationRequiredDocument;
    organizationDocumentId?: number;
    documentType?: DocumentType;
    fileName?: string;
    uploadedOn?: string;
    isActive: boolean;

    constructor(accountId: number, organizationDocumentId?: number, documentType?: DocumentType) {
        this.accountId = accountId;
        this.organizationDocumentId = organizationDocumentId;
        this.organizationRequiredDocument = undefined;
        this.fileName = null;
        this.uploadedOn = null;
        this.documentType = documentType;
        this.isActive = true;
    }
}
  
export enum DocumentType {
    TaxDocument = 0,
    BirthCertificate = 1
}